<script setup lang="ts">
import { VfDialogContainer } from "@/vf"
import { useLocalStorage } from "@vueuse/core"
import { ref, watch } from "vue"
import { RouterView, useRoute, useRouter } from "vue-router"
import DebugBar from "./components/DebugBar.vue"
import OverlayContainer from "./components/OverlayContainer.vue"
import EnterShopOverlay from "./components/overlays/EnterShopOverlay.vue"
import PageFooter from "./components/page-footer/PageFooter.vue"
import PageNavbar from "./components/page-navbar/PageNavbar.vue"
import { useShopAppConfig } from "./composables"
import OfflinePage from "./pages/offline/OfflinePage.vue"
import { useOverlayStore, useRequestUserInfoStore } from "./store"

const { appConfig } = useShopAppConfig()
const isStaging = import.meta.env.VITE_ENVIRONMENT === "staging"
const isDev = import.meta.env.VITE_ENVIRONMENT === "dev"

// initialize the store. this opens the overlay if necessary
useRequestUserInfoStore()

const router = useRouter()
const route = useRoute()
const enterShopDialogShown = ref(false)
const enterShopDontShowAgain = useLocalStorage("enterShopDialogDontShowAgain", false)

// show the enter shop dialog if the route requires it (which is the default). Show it only once and make sure
// it is shown when the user navigates to a page that requires it.
watch(router.currentRoute, () => {
    if (!appConfig.value.customEnterShopDialog) {
        return
    }
    if (router.currentRoute.value.meta?.enterDialog === false) {
        return
    }

    if (enterShopDialogShown.value || enterShopDontShowAgain.value) {
        return
    }

    const overlay = useOverlayStore()
    overlay.open(EnterShopOverlay)

    enterShopDialogShown.value = true
})
</script>

<template>
    <template v-if="appConfig.offline">
        <OfflinePage />
    </template>
    <template v-else>
        <PageNavbar />
        <div class="router-view">
            <RouterView v-slot="{ Component }" :key="route.fullPath">
                <!-- <Transition> -->
                <Suspense>
                    <component :is="Component" />
                </Suspense>
                <!-- </Transition> -->
            </RouterView>
        </div>

        <PageFooter />
        <OverlayContainer />
        <VfDialogContainer />

        <DebugBar v-if="isStaging || isDev" />
    </template>
</template>
